var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 21.833c1.375 0 2.5-.975 2.5-2.166h-5c0 1.191 1.125 2.166 2.5 2.166zm7.5-6.5V9.917c0-3.326-2.037-6.11-5.625-6.847v-.737c0-.899-.838-1.625-1.875-1.625s-1.875.726-1.875 1.625v.737C4.55 3.807 2.5 6.58 2.5 9.917v5.416L0 17.5v1.083h20V17.5l-2.5-2.167zM15 16.417H5v-6.5c0-2.687 1.888-4.875 5-4.875 3.113 0 5 2.188 5 4.875v6.5z"
  })));
}
export default SvgFeed;